var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9997 13.3346H2.99967V3.33464H17.9997M17.9997 1.66797H2.99967C2.07467 1.66797 1.33301 2.40964 1.33301 3.33464V13.3346C1.33301 13.7767 1.5086 14.2006 1.82116 14.5131C2.13372 14.8257 2.55765 15.0013 2.99967 15.0013H8.83301V16.668H7.16634V18.3346H13.833V16.668H12.1663V15.0013H17.9997C18.4417 15.0013 18.8656 14.8257 19.1782 14.5131C19.4907 14.2006 19.6663 13.7767 19.6663 13.3346V3.33464C19.6663 2.40964 18.9163 1.66797 17.9997 1.66797Z",
    fill: "#56595B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComputer);
export default __webpack_public_path__ + "static/media/icon-computer.6e3dfaa8cca0db87439b5e51290b8919.svg";
export { ForwardRef as ReactComponent };